import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';
import DashboardNavbar from 'components/DashboardNavbar';
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDInput from 'components/MDInput';
import MDTypography from 'components/MDTypography';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import { useEffect, useState } from 'react';
import { getBanners } from 'services/banners/get-banners';
import { createBanner } from 'services/banners/create-banner';
import { deleteBanner } from 'services/banners/delete-banner';
import { editBanner } from 'services/banners/edit-banner';

export default function Banners() {
  const [banners, setBanners] = useState([]);
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [imageLink, setImageLink] = useState('');
  const [actionRedirectLink, setActionRedirectLink] = useState('');

  const [editId, setEditId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const handleCreateMenu = () => setOpenAdd(!openAdd);
  const handleOpenEdit = () => setOpenEdit(!openEdit);
  const handleOpenDelete = () => setOpenDelete(!openDelete);

  async function initData() {
    const res = await getBanners();
    setBanners(res?.data || []);
  }

  useEffect(() => {
    initData();
  }, []);

  async function sendData() {
    const res = await createBanner(imageLink, actionRedirectLink);
    if (res?.status === 200 || res?.status === 201) {
      alert('Banner creation successful!');
    } else if (res?.response?.status === 400) {
      alert(res?.response?.data?.message);
    } else {
      alert('Something went wrong!');
    }
    setImageLink('');
    setActionRedirectLink('');
    handleCreateMenu();
    initData();
  }

  async function handleDelete() {
    await deleteBanner(deleteId);
    handleOpenDelete();
    setDeleteId(null);
    initData();
  }

  async function handleEdit() {
    const res = await editBanner(editId, actionRedirectLink);
    if (res?.status === 200 || res?.status === 201) {
      alert('Edit successful!');
    } else if (res?.response?.status === 400) {
      alert(res?.response?.data?.message);
    } else {
      alert('Something went wrong!');
    }
    setActionRedirectLink('');
    handleOpenEdit();
    setEditId(null);
    initData();
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container spacing={1} sx={{ marginTop: '20px' }}>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <MDButton
            color='info'
            onClick={() => {
              setImageLink('');
              setActionRedirectLink('');
              handleCreateMenu();
            }}
          >
            Add new banner
          </MDButton>
        </Grid>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexWrap: 'wrap' }}>
          {banners && banners?.length > 0 ? (
            banners?.map((banner) => (
              <Grid key={banner?.id} item xs={3} sx={{ padding: '15px' }}>
                <MDBox
                  sx={{
                    background: '#27314f',
                    borderRadius: '10px',
                    border: '0.5px solid #fff',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingBottom: '15px'
                  }}
                >
                  <img src={banner?.imageLink} style={{ width: '240px', height: '120px', objectFit: 'cover' }} />
                  <MDBox sx={{ display: 'flex', padding: '10px', gap: '10px' }}>
                    <MDButton
                      onClick={() => {
                        handleOpenEdit();
                        setEditId(banner?.id);
                        setActionRedirectLink(banner?.actionRedirectLink || '');
                      }}
                    >
                      Edit Banner
                    </MDButton>
                    <MDButton
                      onClick={() => {
                        handleOpenDelete();
                        setDeleteId(banner?.id);
                      }}
                    >
                      Delete Banner
                    </MDButton>
                  </MDBox>
                </MDBox>
              </Grid>
            ))
          ) : (
            <MDBox sx={{ width: '100%', textAlign: 'center', paddingBottom: '30px' }}>
              <MDTypography sx={{ fontSize: '14px' }}>No Banners available.</MDTypography>
            </MDBox>
          )}
        </Grid>

        <Dialog open={openAdd} onClose={handleCreateMenu} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
          <DialogTitle id='alert-dialog-title' sx={{ width: '100%', textAlign: 'center' }}>{`Add new banner`}</DialogTitle>
          <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: '5px', padding: '20px 30px' }}>
            <MDTypography sx={{ fontSize: '16px' }}>Redirect link</MDTypography>
            <MDInput type='text' value={actionRedirectLink} onChange={(e) => setActionRedirectLink(e.target.value)} />

            <MDTypography sx={{ fontSize: '16px', marginTop: '10px' }}>Banner Image URL</MDTypography>
            <MDInput type='text' value={imageLink} onChange={(e) => setImageLink(e.target.value)} />
          </DialogContent>
          <DialogActions>
            <MDButton variant='text' onClick={handleCreateMenu}>
              Close
            </MDButton>
            <MDButton color='info' onClick={() => sendData()}>
              Save
            </MDButton>
          </DialogActions>
        </Dialog>

        <Dialog open={openDelete} onClose={handleOpenDelete} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
          <DialogTitle id='alert-dialog-title' sx={{ width: '100%', textAlign: 'center' }}>{`Are you sure you want to delete this banner?`}</DialogTitle>
          <DialogActions>
            <MDButton variant='text' color='error' onClick={() => handleDelete()}>
              Yes
            </MDButton>
            <MDButton variant='text' onClick={() => handleOpenDelete()}>No</MDButton>
          </DialogActions>
        </Dialog>

        <Dialog open={openEdit} onClose={handleOpenEdit} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
          <DialogTitle id='alert-dialog-title' sx={{ width: '100%', textAlign: 'center' }}>{`Edit banner`}</DialogTitle>
          <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: '5px', padding: '20px 30px' }}>
            <MDTypography sx={{ fontSize: '16px' }}>Redirect link</MDTypography>
            <MDInput type='text' value={actionRedirectLink} onChange={(e) => setActionRedirectLink(e.target.value)} />
          </DialogContent>
          <DialogActions>
            <MDButton variant='text' onClick={handleOpenEdit}>Close</MDButton>
            <MDButton color='info' onClick={() => handleEdit()}>Save</MDButton>
          </DialogActions>
        </Dialog>
      </Grid>
    </DashboardLayout>
  );
}


